export enum SigningButtonType {
  SignIn = 'SignIn',
  SignUp = 'SignUp',
  LogIn = 'LogIn',
}
